export const modalMixin = {
    data () {
        return {
            // モーダル外背景スクロール位置
            scrollPosition: {
                top: '0px',
            },
            // モーダル外背景スクロール量
            scrollAmount: 0
        };
    },
    methods: {
        /** ---------------------------------------------------------------------------------
         * モーダルを開いた時のモーダル外背景処理
         * ----------------------------------------------------------------------------------
         * 基本はoverflow:hiddenで制御していますが、iphone(safari)のみ制御ができないので、
         * レスポンシブ時はposition:fixedを適用させています。
         * position:fixedを適用した場合、ボタン押下時にモーダル外背景が先頭に戻ってしまうのを防ぐ為、
         * 押下時のスクロール量を取得し、モーダル外背景位置を制御させています。
         *----------------------------------------------------------------------------------*/
        openModalScroll: function () {
            this.scrollAmount = window.scrollY;
            this.scrollPosition.top = -this.scrollAmount + 'px';
        },
        /** ------------------------------------------------------------------------------
         * モーダルを閉じた時のモーダル外背景処理
         * -------------------------------------------------------------------------------
         * モーダルを開く時と同様に、閉じるボタン押下時に背景が先頭に戻ってしまうのを防ぐ為、
         * 開くボタン押下時に取得したスクロール位置まで移動させています。
         *-------------------------------------------------------------------------------*/
        closeModalScroll: function () {
            this.scrollPosition.top = '';
            this.$nextTick(function() {
                window.scrollTo(0, this.scrollAmount);
            });
        }
    }
}